
import { AnimationShell } from '@/components';
import { OpportunityItemList } from '@/features/opportunities/types';
import { MyOpportunitiesTable } from '../table';

export type MyOpportunitiesItemsProps = {
  readonly opportunities: OpportunityItemList[];
};

export function MyOpportunitiesItems({ opportunities }: MyOpportunitiesItemsProps) {
  return (
    <AnimationShell type="opacity" className="grid place-items-stretch gap-6">
      <MyOpportunitiesTable opportunities={opportunities} />
    </AnimationShell>
  );
}
